import React from 'react';

import { Box, ButtonGroup } from '@mui/material';

import { FORM_FIELD_TYPES, FormField } from '../../../components/form/form-field';
import SaveButton from '../../../components/form/save-button';
import SchemaEditor from '../../../components/form/schema-editor';
import { useNodeContext } from '../../../context/node-context';

const SqlServerForm = ({ form, onSubmit, onChange }) => {
  const { errors } = form.formState;
  const formControl = form.control;
  const { node } = useNodeContext();
  const { id } = node;

  return (
    <Box
      component="form"
      onSubmit={form.handleSubmit(onSubmit)}
      onReset={form.reset}
      onChange={onChange}
    >
      <FormField
        controlId="sqlServerFormName"
        label="name"
        name="name"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter name"
        required
        error={errors?.name?.message}
      />
      <FormField
        controlId="sqlServerFormType"
        label="type"
        name="type"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        disabled
        error={errors?.type?.message}
      />
      <FormField
        controlId="sqlServerFormDelayedRead"
        label="delayedRead"
        name="delayedRead"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.CHECKBOX}
      />
      <FormField
        controlId="sqlServerFormParameterizedBy"
        label="parameterizedBy"
        name="parameterizedBy"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        error={errors?.parameterizedBy?.message}
      />
      <FormField
        controlId="sqlServerFormFormat"
        label="format"
        name="format"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        error={errors?.format?.message}
      />
      <FormField
        controlId="sqlServerFormConnectionKey"
        label="connectionKey"
        name="connectionKey"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        error={errors?.connectionKey?.message}
      />
      <FormField
        controlId="sqlServerFormDatabaseName"
        label="databaseName"
        name="properties.databaseName"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter Database Name"
        error={errors?.properties?.databaseName?.message}
      />
      <FormField
        controlId="sqlServerFormDriver"
        label="driver"
        name="properties.driver"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter Driver"
        error={errors?.properties?.driver?.message}
      />
      <FormField
        controlId="sqlServerFormSqlQuery"
        label="sqlQuery"
        name="properties.sqlQuery"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.SPARKQL}
        placeholder="Enter SQL Query"
        rows={10}
        error={errors?.properties?.sqlQuery?.message}
      />
      <FormField
        controlId="sqlServerFormHost"
        label="host"
        name="properties.host"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter Host"
        error={errors?.properties?.host?.message}
      />
      <FormField
        controlId="sqlServerFormPort"
        label="port"
        name="properties.port"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter Port"
        error={errors?.properties?.port?.message}
      />
      <FormField
        controlId="sqlServerFormUsername"
        label="username"
        name="properties.username"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter Username"
        error={errors?.properties?.username?.message}
      />
      <FormField
        controlId="sqlServerFormPassword"
        label="password"
        name="properties.password"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        type="password"
        placeholder="Enter Password"
        error={errors?.properties?.password?.message}
      />
      <FormField
        controlId="sqlServerFormParameters"
        label="parameters"
        name="properties.parameters"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.JSON}
        placeholder="Enter Parameters"
        error={errors?.properties?.parameters?.message}
      />
      <FormField
        controlId="sqlServerFormProcedureName"
        label="procedureName"
        name="properties.procedureName"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter Procedure Name"
        error={errors?.properties?.procedureName?.message}
      />
      <SchemaEditor form={form} id={id} />
      <ButtonGroup>
        <SaveButton />
      </ButtonGroup>
    </Box>
  );
};

export default SqlServerForm;
